  <section class="dashboard-main container-fluid">
    <div class="contents-main">
      <div class="card table-card">
        <!-- Title, filters and the page action share one row at the top of
             the card rather than stacking above it. -->
        <div class="table-toolbar">
          <h1 class="table-toolbar__title">Plants List</h1>
          <div class="sb-filter-holder sb-filter-holder--inline">
            <div class="input-wrapper">
              <ng-select class="sb-filter-field sb-filter-field--md" (change)="selectContractType($event)"
                placeholder="Contract Type" [items]="contractTypeList" bindLabel="name" bindValue="id">
              </ng-select>
            </div>

            <div class="input-wrapper">
              <ng-select class="sb-filter-field sb-filter-field--md" placeholder="Region"
                (change)="selectRegion($event);getCitiesByRegionMain($event)" [items]="regionList" bindLabel="name"
                bindValue="id" [loading]="regionLoading" loadingText="Loading regions...">
              </ng-select>
            </div>

            <div class="input-wrapper">
              <ng-select class="sb-filter-field sb-filter-field--md" (ngModelChange)="selectCity($event)" placeholder="City"
                [items]="cititiesList" bindLabel="name" bindValue="id" [(ngModel)]="selectedCity"
                [loading]="citiesLoading" loadingText="Loading cities..." notFoundText="No city found">
              </ng-select>
            </div>

            <div class="input-wrapper">
              <ng-select class="sb-filter-field sb-filter-field--md" (change)="selctPlantlistStatus($event)"
                placeholder="Plant Status">
                <ng-option *ngFor="let sourceItem of plantStatuslst" [value]="sourceItem.id">{{sourceItem.name}}</ng-option>
              </ng-select>
            </div>

            <div class="input-wrapper">
              <ng-select class="sb-filter-field sb-filter-field--md" (change)="selctPlantlistType($event)"
                placeholder="Plant Type">
                <ng-option *ngFor="let sourceItem of plantTypelst" [value]="sourceItem.id">{{sourceItem.name}}</ng-option>
              </ng-select>
            </div>
            <div class="btn-group input-wrapper sb-filter-search-group" role="group">
              <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                (input)="searchData($event)">
              <button type="button" class="btn sb-filter-search-btn">
                <!-- <i class="ri-search-line"></i> -->
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>
          <button class="btn btn-dark rounded" (click)="downloadReport()" [disabled]="isDownloading">
            <ng-container *ngIf="!isDownloading">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                class="me-2">
                <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Download
            </ng-container>
            <ng-container *ngIf="isDownloading">
              <span class="spinner-border spinner-border-sm align-middle me-2"></span>
              Downloading
            </ng-container>
          </button>
        </div>
        <!-- .table-wrap is position:relative, so the overlay below is bounded
             by the table instead of covering the whole page on every filter,
             search keystroke or page change. -->
        <div class="table-wrap" [class.is-loading]="tableLoader">
          <div class="loaderwrapper" *ngIf="tableLoader">
            <span class="loader"></span>
          </div>
          <div class="table-main">
            <ngx-datatable class="material" [rows]="detail" [columnMode]="'force'" [headerHeight]="50"
              [footerHeight]="0" [rowHeight]="'auto'" (sort)="onSort($event)"
              [messages]="{emptyMessage: 'No Plant found.'}">
              <!-- Status Column -->
              <!-- <ngx-datatable-column name="Status" [sortable]="false" [width]="60"> -->
                <ngx-datatable-column name="Status" [sortable]="false" headerClass="col-narrow" cellClass="col-narrow">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div class="d-flex align-items-center gap-1 flex-wrap">
                    <span *ngIf="row.status === 'Online'" class="status-circle-online flex-shrink-0"
                      title="Online"></span>
                    <span *ngIf="row.status === 'Offline'" class="status-circle-offline flex-shrink-0"
                      title="Offline"></span>
                    <span *ngIf="row.status === 'Faulty'" class="status-circle-faulty flex-shrink-0"
                      title="Faulty"></span>
                  </div>
                </ng-template>
              </ngx-datatable-column>

              <!-- <ngx-datatable-column name="Plant Name" [sortable]="false"> -->
                <ngx-datatable-column name="Plant Name" [sortable]="false" headerClass="col-name" cellClass="col-name">
                <ng-template ngx-datatable-header-template>
                  <div class="custom-sort-header d-flex">
                    <span class="cursor-pointer" (click)="sortPlants('plantName')">
                      Plant Name
                    </span>
                    <span class="sort-btn"
                      [ngClass]="{ 'datatable-icon-sort-unset': sortOrderPlantName === null, 'datatable-icon-up': sortOrderPlantName === 'asc', 'datatable-icon-down': sortOrderPlantName === 'desc' }"></span>
                  </div>

                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                    <a href="javascript:;" class="text-underline-hover" (click)="plantDetail(row)">{{ row.plantName }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Capacity" [sortable]="false">
                <ng-template ngx-datatable-header-template>
                  <div class="custom-sort-header d-flex">
                    <span class="cursor-pointer" (click)="sortPlants('capacity')">
                      Capacity (kWp)
                    </span>
                    <!-- style="padding-top: 8px;" -->
                    <span class="sort-btn" 
                      [ngClass]="{ 'datatable-icon-sort-unset': sortOrderCapacity === null, 'datatable-icon-up': sortOrderCapacity === 'asc', 'datatable-icon-down': sortOrderCapacity === 'desc' }"></span>
                  </div>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span>{{ row.capacity }}</span>
                </ng-template>
              </ngx-datatable-column>

              <!-- Current Power Column -->
              <ngx-datatable-column name="Current Power (kW)" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.currentPower }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Specific Yield Column -->
              <ngx-datatable-column name="Specific Yield (kWh/kWp)" prop="specificYield" [sortable]="true">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.specificYield }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Energy Today Column -->
              <ngx-datatable-column name="Todays Generation (kWh)" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.energyToday }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Data Delay Column -->
              <ngx-datatable-column name="Data Delay" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.dataDelay }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Availability Chart Column -->
              <!-- <ngx-datatable-column name="Availability" [sortable]="false"> -->
                <ngx-datatable-column name="Availability" [sortable]="false" headerClass="col-chart" cellClass="col-chart">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <ng-container *ngIf="!availabilityGraphLoader; else loadingAvailability">
                    <highcharts-chart [Highcharts]="Highcharts" [options]="AvailabilityPower[row.stationCode]"
                      style="width: 100%; height: 60px; display: block; margin: 0;">
                      <!-- style="width: 80px; height: 60px; display: block; margin: 0px;" -->

                    </highcharts-chart>
                  </ng-container>
                  <ng-template #loadingAvailability>
                    <span class="graph-loader"></span>
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>


              <!-- Normalized Power Chart Column -->
              <!-- <ngx-datatable-column name="Normalized Power" [sortable]="false"> -->
                <ngx-datatable-column name="Normalized Power" [sortable]="false" headerClass="col-chart" cellClass="col-chart">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <ng-container *ngIf="!normalizedGraphLoader; else loadingNormalized">
                    <highcharts-chart [Highcharts]="Highcharts" [options]="NormalizedPower[row.stationCode]"
                      style="width: 100%; height: 60px; display: block; margin: 0;">
                      <!-- style="width: 80px; height: 60px; display: block; margin: 0px;" -->
                    </highcharts-chart>
                  </ng-container>
                  <ng-template #loadingNormalized>
                    <span class="graph-loader"></span>
                  </ng-template>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Bell Icon 1" [sortable]="false" headerClass="col-bell" cellClass="col-bell">
                <ng-template ngx-datatable-header-template>
                  <svg id="bell-solid-badged" xmlns="http://www.w3.org/2000/svg" width="22.434" height="23.369"
                    viewBox="0 0 22.434 23.369">
                    <path id="Path_5473" data-name="Path 5473"
                      d="M22.308,44.268a1.875,1.875,0,0,0,1.812-1.6H20.427a1.875,1.875,0,0,0,1.882,1.6Z"
                      transform="translate(-11.811 -20.899)" fill="currentColor" />
                    <path id="Path_5474" data-name="Path 5474"
                      d="M24.991,20.873l-.239-.211A10.09,10.09,0,0,1,22.99,18.6a8.868,8.868,0,0,1-.948-3.377V11.758A7.668,7.668,0,0,0,21.93,10.5a5.266,5.266,0,0,1-4.206-5.168V4.891a7.422,7.422,0,0,0-2.331-.7V3.3a.937.937,0,1,0-1.875,0v.92a7.591,7.591,0,0,0-6.53,7.534v3.469A8.868,8.868,0,0,1,6.04,18.6a10.111,10.111,0,0,1-1.734,2.057l-.239.211v1.98H24.991Z"
                      transform="translate(-4.067 -1.822)" fill="currentColor" />
                    <ellipse id="Ellipse_1427" data-name="Ellipse 1427" cx="3.511" cy="3.511" rx="3.511" ry="3.511"
                      transform="translate(15.413 0)" fill="currentColor" />
                  </svg>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="text-notify">{{ row.majorAlarms }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Bell Icon 2" [sortable]="false" headerClass="col-bell" cellClass="col-bell">
                <ng-template ngx-datatable-header-template>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22.478" height="24.523" viewBox="0 0 22.478 24.523">
                    <g id="Group_2315" data-name="Group 2315" transform="translate(0 0)">
                      <path id="Path_5475" data-name="Path 5475"
                        d="M27.9,23.035l-.256-.226A10.839,10.839,0,0,1,25.75,20.6a9.527,9.527,0,0,1-1.018-3.628V13.244a8.154,8.154,0,0,0-7.12-8.109V4.163a1.007,1.007,0,1,0-2.014,0v.988A8.154,8.154,0,0,0,8.56,13.244V16.97A9.527,9.527,0,0,1,7.542,20.6a10.862,10.862,0,0,1-1.863,2.21l-.256.226v2.127H27.9Z"
                        transform="translate(-5.422 -3.156)" fill="currentColor" />
                      <path id="Path_5476" data-name="Path 5476" d="M27.235,56.889a2,2,0,0,0,3.96,0Z"
                        transform="translate(-17.98 -34.09)" fill="currentColor" />
                    </g>
                  </svg>
                </ng-template>
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="text-notify2">{{ row.minorAlarms }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Inverter Status" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <span class="nowrap text-center status-list">
                    <span class="square-status" style="background: #00D54E">{{ row.inverterState.connected }}</span>
                    <span class="square-status" style="background: #E9093F">{{ row.inverterState.disconnected }}</span>
                    <span class="square-status" style="background: #848177">{{ row.inverterState.faulty }}</span>
                  </span>
                </ng-template>
              </ngx-datatable-column>

              <!-- Active Work Orders Column -->
              <ngx-datatable-column name="Active Work Orders" [sortable]="false">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.activeWorkOrders }}
                </ng-template>
              </ngx-datatable-column>

              <!-- Specific Yield Yesterday Column -->
              <ngx-datatable-column name="Specific Yield Yesterday" [sortable]="true">
                <ng-template ngx-datatable-cell-template let-row="row">
                  {{ row.specificYieldYesterday.toFixed(2) }}
                </ng-template>
              </ngx-datatable-column>
              <!-- Action Column -->
              <!-- Pinned narrow: columnMode 'force' otherwise gives this
                   kebab-only column the same share as the data columns. -->
              <!-- <ngx-datatable-column name="Action" [sortable]="false" [width]="60" [minWidth]="60" [maxWidth]="60"
                [canAutoResize]="false" [resizeable]="false"> -->
                <ngx-datatable-column name="Action" [sortable]="false" headerClass="col-narrow" cellClass="col-narrow">
                <ng-template ngx-datatable-cell-template let-row="row">
                  <div ngbDropdown container="body" placement="bottom-end" class="d-inline-block action-dropdown"
                    *ngIf="permissionsReady && (permissions.canView || permissions.canEdit)">
                    <button type="button" class="action-btn" ngbDropdownToggle aria-label="Actions">
                      <svg width="3" height="14" viewBox="0 0 3 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M3 12.5165C3 12.9231 2.85278 13.272 2.55833 13.5632C2.26389 13.8544 1.91111 14 1.5 14C1.08889 14 0.736112 13.8544 0.441667 13.5632C0.147223 13.272 0 12.9231 0 12.5165C0 12.1099 0.147223 11.761 0.441667 11.4698C0.736112 11.1786 1.08889 11.033 1.5 11.033C1.77222 11.033 2.02222 11.1016 2.25 11.239C2.47778 11.3709 2.66111 11.5495 2.8 11.7747C2.93333 11.9945 3 12.2418 3 12.5165Z"
                          fill="#666666" />
                        <path
                          d="M3 7C3 7.40659 2.85278 7.75549 2.55833 8.0467C2.26389 8.33791 1.91111 8.48352 1.5 8.48352C1.08889 8.48352 0.736112 8.33791 0.441667 8.0467C0.147223 7.75549 0 7.40659 0 7C0 6.59341 0.147223 6.24451 0.441667 5.9533C0.736112 5.66209 1.08889 5.51648 1.5 5.51648C1.77222 5.51648 2.02222 5.58517 2.25 5.72253C2.47778 5.8544 2.66111 6.03297 2.8 6.25824C2.93333 6.47802 3 6.72527 3 7Z"
                          fill="#666666" />
                        <path
                          d="M3 1.48351C3 1.89011 2.85278 2.23901 2.55833 2.53022C2.26389 2.82143 1.91111 2.96703 1.5 2.96703C1.08889 2.96703 0.736112 2.82143 0.441667 2.53022C0.147223 2.23901 0 1.89011 0 1.48351C0 1.07692 0.147223 0.728022 0.441667 0.436812C0.736112 0.145604 1.08889 0 1.5 0C1.77222 0 2.02222 0.0686817 2.25 0.206044C2.47778 0.337913 2.66111 0.516483 2.8 0.741757C2.93333 0.961538 3 1.20879 3 1.48351Z"
                          fill="#666666" />
                      </svg>
                    </button>

                    <div ngbDropdownMenu>
                      <button type="button" ngbDropdownItem *ngIf="permissions.canView" (click)="clusterDetail(row)">
                        Cluster
                      </button>
                      <button type="button" ngbDropdownItem *ngIf="permissions.canEdit"
                        (click)="openConfig(row, contractType)">
                        Plant Association
                      </button>
                    </div>
                  </div>
                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>
            <div *ngIf="permissionsReady && !permissions.canView" class="no-access text-center p-4">
              You don’t have permission to view this data.
            </div>
            <div class="table-meta">
              <div class="entries">
                <!-- <span>Show</span>
                    <select>
                        <option>12</option>
                    </select> -->
                <span>Total Records: {{this.total_items }}</span>
              </div>
              <nav class="table-pagination">
                <ul>
                  <li>
                    <div class="go-to-page d-flex align-items-center">
                      <label>Go to Page:</label>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo" min="1"
                        [max]="total_pages" (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                      <div class="input-group-append">
                        <button class="btn btn-primary" type="button" (click)="goToPage(pageToGo); pageToGo = null"
                          [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                      </div>
                    </div>
                  </li>
                  <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                      [class.disabled]="current_page === 1">1</a>
                  </li>
                  <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                        class="fa fa-chevron-left"></i></a>
                  </li>
                  <li><a class="active">{{ current_page }}</a></li>
                  <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                      [class.disabled]="current_page === total_pages"><i class="fa fa-chevron-right"></i></a></li>
                  <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                      [class.disabled]="current_page === total_pages">{{this.total_pages}}</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

<ng-template #contractType let-c="close" let-d="dismiss">
  <form [formGroup]="addContractTypeForm" (ngSubmit)="upadatePlantAssocitation()">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Plant Association Detail</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click'); resetForm()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
          <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 form-styles my-3">
          <label for="typeahead-basic">Contract Type <span class="text-danger">*</span></label>
          <ng-select placeholder="Select Contract Type" formControlName="contractType" [items]="contractTypeList"
            bindLabel="name" bindValue="id">
          </ng-select>
          <small class="text-danger" *ngIf="
                            !addContractTypeForm.get('contractType').valid &&
                            addContractTypeForm.get('contractType').touched">
            Please Select a Contract Type</small>
        </div>
        <div class="col-md-12 form-styles my-3">
          <label for="typeahead-basic">Region <span class="text-danger">*</span></label>
          <ng-select placeholder="Select Region" formControlName="region" [items]="regionList" bindLabel="name"
            bindValue="id" (change)="getCitiesByRegion($event)">
          </ng-select>
          <small class="text-danger" *ngIf="
                            !addContractTypeForm.get('region').valid &&
                            addContractTypeForm.get('region').touched">
            Please Select a Region</small>
        </div>
        <div class="col-md-12 form-styles my-3">
          <label for="typeahead-basic">City <span class="text-danger">*</span></label>
          <ng-select placeholder="Select City" formControlName="city" [items]="citiesByRegionList" bindLabel="name"
            bindValue="id">
          </ng-select>
          <small class="text-danger" *ngIf="
                            !addContractTypeForm.get('city').valid &&
                            addContractTypeForm.get('city').touched">
            Please Select a City</small>
        </div>
      </div>
    </div>
    <div class="modal-footer no-bg">
      <button type="button" class="btn btn-outline-dark" aria-label="Close" (click)="d('Cross click'); resetForm()">
        Cancel
      </button>
      <button type="button" class="btn btn-orange" [disabled]="addContractTypeForm.invalid" (click)="d('Cross click')"
        type="submit">
        Save
      </button>
    </div>
  </form>
</ng-template>
<ng-template #noAssociation>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7.50002 18.3333H12.5C16.6667 18.3333 18.3334 16.6666 18.3334 12.5V7.49996C18.3334 3.33329 16.6667 1.66663 12.5 1.66663H7.50002C3.33335 1.66663 1.66669 3.33329 1.66669 7.49996V12.5C1.66669 16.6666 3.33335 18.3333 7.50002 18.3333Z"
      stroke="#6D6D6D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.975 15.4166V12.1666" stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M12.975 6.20837V4.58337" stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M12.975 10.5417C14.1716 10.5417 15.1417 9.57166 15.1417 8.37504C15.1417 7.17842 14.1716 6.20837 12.975 6.20837C11.7784 6.20837 10.8083 7.17842 10.8083 8.37504C10.8083 9.57166 11.7784 10.5417 12.975 10.5417Z"
      stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.02502 15.4166V13.7916" stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M7.02502 7.83337V4.58337" stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M7.025 13.7917C8.22162 13.7917 9.19167 12.8217 9.19167 11.625C9.19167 10.4284 8.22162 9.45837 7.025 9.45837C5.82839 9.45837 4.85834 10.4284 4.85834 11.625C4.85834 12.8217 5.82839 13.7917 7.025 13.7917Z"
      stroke="#6D6D6D" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</ng-template>